import { AfterViewInit, Component } from '@angular/core';
import { ScriptService } from './core/services/script/script.service';
import Intercom from "@intercom/messenger-js-sdk";
import { AuthenticationService } from './core/services/authentication/authentication.service';
import { IntercomData } from './models/interfaces/intercomData';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [],
})
export class AppComponent implements AfterViewInit {

  userSub: Subscription;
  lastUserId: string | null = null;
  title = 'admin-panel';
  appID = 'xlyl0fh2';

  constructor(loadService: ScriptService,
    private authenticationService: AuthenticationService
  ) {
    loadService.checkScriptLoaded();
  }

  ngAfterViewInit(): void {
    this.userSub = this.authenticationService.currentLoggedInUser.subscribe(user => {
      this.handleIntercom(user?.user);
    });
  }

  handleIntercom(user) {
    // Prevent duplicate Intercom calls for the same user
    const userId = user?.id || null;
    if (userId === this.lastUserId) return;
    this.lastUserId = userId;

    const intercomData: IntercomData = {
      app_id: this.appID,
      created_at: Date.now(),
      domain: this.title,
      ...(user && {
        user_id: user.id || '',
        name: user.full_name || '',
        email: user.profile?.email || '',
        user_type: user.profile?.user_type_object?.name,
      }),
    };
    Intercom({ ...intercomData });
  }

  ngOnDestroy(): void {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }
}
